(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fanaze-price-lock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fanaze-price-lock')) {
    const sharedDeadlines = new Map();
    customElements.define('fanaze-price-lock', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const time = this.querySelector('.fpl__time');
        const timerLabel = this.timerLabel ||= time.getAttribute('aria-label');
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.digits = [];
        this.inViewport = false;
        this.observer = new IntersectionObserver(entries => {
          this.inViewport = entries[0].isIntersecting;
        });
        this.observer.observe(this);
        const parsed = Number.parseInt(this.dataset.durationMinutes, 10);
        const minutes = Number.isFinite(parsed) && parsed >= 5 && parsed <= 360 ? parsed : 180;
        const duration = minutes * 60000;
        const key = `fanaze:price-lock:store:${minutes}:v1`;
        const state = sharedDeadlines.get(key) || { deadline: 0 };
        sharedDeadlines.set(key, state);
        const readDeadline = () => {
          try {
            const saved = Number(localStorage.getItem(key));
            if (Number.isSafeInteger(saved) && saved > 0 && saved <= Date.now() + duration) return saved;
          } catch {}
          return 0;
        };
        const saveDeadline = () => {
          try { localStorage.setItem(key, String(state.deadline)); } catch {}
        };
        const migrateDeadline = now => {
          let earliest = 0;
          try {
            for (let index = 0; index < localStorage.length; index++) {
              const legacyKey = localStorage.key(index);
              if (!legacyKey?.startsWith('fanaze:fomo-deadline:') || !legacyKey.endsWith(`:${minutes}`)) continue;
              const saved = Number(localStorage.getItem(legacyKey));
              if (Number.isSafeInteger(saved) && saved > now && saved <= now + duration && (!earliest || saved < earliest)) earliest = saved;
            }
          } catch {}
          return earliest;
        };
        const now = Date.now();
        const saved = readDeadline();
        if (saved) state.deadline = saved;
        if (!state.deadline || state.deadline > now + duration) {
          state.deadline = migrateDeadline(now) || now + duration;
          saveDeadline();
        }
        const pad = value => String(value).padStart(2, '0');
        let lastValue = '';
        let lastSeconds = null;
        const draw = (value, seconds) => {
          if (value === lastValue) return;
          if (value.length !== lastValue.length) {
            this.digits.forEach(digit => digit.animation?.cancel());
            this.digits = [];
            time.replaceChildren();
            for (const character of value) {
              const column = document.createElement('span');
              column.setAttribute('aria-hidden', 'true');
              if (character === ':') {
                column.className = 'fpl__separator';
                column.textContent = ':';
              } else {
                column.className = 'fpl__digit';
                const reel = document.createElement('span');
                const current = document.createElement('span');
                const previous = document.createElement('span');
                reel.className = 'fpl__reel';
                current.textContent = character;
                previous.textContent = character;
                reel.append(current, previous);
                column.append(reel);
                this.digits.push({ reel, current, previous });
              }
              time.append(column);
            }
          }
          const animate = lastSeconds === seconds + 1 && this.inViewport && !document.hidden && !reducedMotion.matches;
          [...value.replaceAll(':', '')].forEach((character, index) => {
            const digit = this.digits[index];
            if (digit.current.textContent === character) return;
            digit.animation?.cancel();
            digit.previous.textContent = digit.current.textContent;
            digit.current.textContent = character;
            if (animate) digit.animation = digit.reel.animate(
              [{ transform: 'translateY(-50%)' }, { transform: 'translateY(0)' }],
              { duration: 240, easing: 'cubic-bezier(.2,.65,.3,1)' }
            );
          });
          time.setAttribute('aria-label', `${timerLabel}: ${value}`);
          lastValue = value;
          lastSeconds = seconds;
        };
        const render = () => {
          const now = Date.now();
          if (state.deadline <= now) {
            const saved = readDeadline();
            if (saved) state.deadline = saved;
            if (state.deadline <= now) {
              state.deadline += (Math.floor((now - state.deadline) / duration) + 1) * duration;
              saveDeadline();
            }
          }
          const seconds = Math.max(1, Math.ceil((state.deadline - now) / 1000));
          draw(`${pad(Math.floor(seconds / 3600))}:${pad(Math.floor(seconds % 3600 / 60))}:${pad(seconds % 60)}`, seconds);
        };
        const sync = () => {
          clearInterval(this.interval);
          this.interval = null;
          const saved = readDeadline();
          if (saved) state.deadline = saved;
          render();
          if (!document.hidden) this.interval = setInterval(render, 1000);
        };
        document.addEventListener('visibilitychange', sync, { signal });
        window.addEventListener('pageshow', sync, { signal });
        window.addEventListener('storage', event => {
          if (event.key === key || event.key === null) sync();
        }, { signal });
        sync();
        this.hidden = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.digits?.forEach(digit => digit.animation?.cancel());
        clearInterval(this.interval);
        this.interval = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
